// Shared physical case identity for the 3D Workbench.
// Mirrors /db's stable contract: topology family and physical orientation are orthogonal.
// `reference` + H>L => vertical_reference; `sandwich` + H>L => vertical_sandwich.

function finite(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

function parseDimensions(caseObj = {}) {
  const direct = [finite(caseObj?.l), finite(caseObj?.w), finite(caseObj?.h)];
  if (direct.every(v => v > 0)) return direct;

  const raw = caseObj?.caseDimensions ?? caseObj?.dims ?? caseObj?.dimensions ?? '';
  if (Array.isArray(raw)) {
    const dims = raw.slice(0, 3).map(finite);
    if (dims.length === 3 && dims.every(v => v > 0)) return dims;
  }

  const dims = String(raw || '')
    .replace(/mm/gi, '')
    .split(/\s*[x×]\s*/i)
    .slice(0, 3)
    .map(finite);
  return dims.length === 3 ? dims : direct;
}

export function normalizePhysicalLayoutFamily(value = 'reference') {
  const raw = String(value || 'reference').trim().toLowerCase();
  if (raw.includes('sandwich')) return 'sandwich';
  if (raw.includes('console')) return 'console';
  // APU and unknown/generic layouts retain the established reference spatial family.
  return 'reference';
}

export function classifyPhysicalLayout(caseObj = {}, { family = null } = {}) {
  const [l, w, h] = parseDimensions(caseObj);
  const resolvedFamily = normalizePhysicalLayoutFamily(
    family ?? caseObj?.style ?? caseObj?.layout ?? caseObj?._layout ?? caseObj?.declaredLayout ?? 'reference'
  );
  const vertical = l > 0 && h > 0 && h > l;

  let layoutId = resolvedFamily;
  if (resolvedFamily === 'reference' && vertical) layoutId = 'vertical_reference';
  else if (resolvedFamily === 'sandwich' && vertical) layoutId = 'vertical_sandwich';

  return Object.freeze({
    family: resolvedFamily,
    orientation: vertical ? 'vertical' : 'standard',
    vertical,
    layoutId,
    l, w, h,
    source: l > 0 && h > 0 ? 'catalog_dimensions' : 'family_only'
  });
}
